import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--auth-phone" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "認証用電話番号 設定", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = {
  key: 0,
  class: "p-mypage__field-container"
}
const _hoisted_5 = { class: "p-fields p-fields--confirm" }
const _hoisted_6 = { class: "c-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "現在の認証用電話番号", -1)
const _hoisted_8 = { class: "c-field__label" }
const _hoisted_9 = { class: "p-errors" }
const _hoisted_10 = { class: "c-error" }
const _hoisted_11 = { class: "p-fields" }
const _hoisted_12 = {
  key: 0,
  class: "c-field"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "newAuthPhone"
}, "新しい認証用電話番号", -1)
const _hoisted_14 = { class: "c-field__body" }
const _hoisted_15 = { class: "c-field__input" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "c-error" }
const _hoisted_18 = {
  key: 1,
  class: "c-error"
}
const _hoisted_19 = { class: "c-field has-submit has-mt" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "確認コードを送信する", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "解除用確認コードを送信する", -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_27 = [
  _hoisted_26
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_Form, {
        onSubmit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.authPhone, this))),
        "validation-schema": _ctx.currentAuthPhoneRef === '' ? _ctx.schema : undefined
      }, {
        default: _withCtx(({ errors, meta }) => [
          (_ctx.isReady)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("fieldset", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.maskPhoneNumber(_ctx.currentAuthPhoneRef) || '未設定'), 1)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errorMsgRef), 1)
                ], 512), [
                  [_vShow, _ctx.errorMsgRef]
                ]),
                _createElementVNode("fieldset", _hoisted_11, [
                  (_ctx.currentAuthPhoneRef === '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _withDirectives(_createElementVNode("div", null, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                                class: "country-select"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: country.code,
                                    value: country.code
                                  }, _toDisplayString(country.flag) + " " + _toDisplayString(country.name), 9, _hoisted_16))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.selectedCountry]
                              ])
                            ], 512), [
                              [_vShow, false]
                            ]),
                            _createVNode(_component_Field, {
                              type: "text",
                              id: "newAuthPhone",
                              name: "newAuthPhone",
                              modelValue: _ctx.newAuthPhoneRef,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newAuthPhoneRef) = $event)),
                              placeholder: "00012345678"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.newAuthPhone), 513), [
                    [_vShow, errors.newAuthPhone]
                  ]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.currentAuthPhoneRef === '' ? 'ご入力の電話番号に、確認コードを記載したSMSをお送りします。' : '解除する電話番号に確認コードを記載したSMSをお送りします。'), 1),
                  (_ctx.currentAuthPhoneRef !== '' )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString('一度解除すると解除前の電話番号は別のアカウントへ一定期間再登録できません。')))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_19, [
                    (!_ctx.currentAuthPhoneRef)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "submit",
                          class: "c-btn is-submit",
                          disabled: !(_ctx.newAuthPhoneRef !== '' && meta.valid && !_ctx.isDeterringRef),
                          onClick: _cache[2] || (_cache[2] = () => { _ctx.submitType = 'confirm' })
                        }, _hoisted_22, 8, _hoisted_20))
                      : _createCommentVNode("", true),
                    (_ctx.currentAuthPhoneRef)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "submit",
                          class: "c-btn is-submit",
                          disabled: !(_ctx.currentAuthPhoneRef !== '' && meta.valid && !_ctx.isDeterringRef),
                          onClick: _cache[3] || (_cache[3] = () => { _ctx.submitType = 'delete' })
                        }, _hoisted_25, 8, _hoisted_23))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["c-btn c-btn--outline", { 'is-disabled':_ctx.isDeterringRef }]),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
                    }, _hoisted_27, 2)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ])
  ], 64))
}